import * as React from "react";
import { Route, Switch } from "react-router-dom";
import {Redirect} from "react-router";
import { RouteComponentProps } from "react-router";

import UserProfileLayout from "../UserProfileLayout";
import UserApiKeys from "../UserApiKeys/UserApiKeys";
import UserProfile from "../UserProfile/UserProfile";
import UserRecentActivity from "../UserRecentActivity/UserRecentActivity";
import UserLogins from "../UserLogins/UserLogins";
import { renderWithLayout } from "components/RenderWithLayout/RenderWithLayout";
import ReloadableRoute from "components/ReloadableRoute/ReloadableRoute";
import { RedirectAs404 } from "components/NotFound/NotFound";

const userProfile = renderWithLayout(UserProfileLayout)(UserProfile);
const userRecentActivity = renderWithLayout(UserProfileLayout)(UserRecentActivity);
const userApiKeys = renderWithLayout(UserProfileLayout)(UserApiKeys);
const userLogins = renderWithLayout(UserProfileLayout)(UserLogins);

export class UserProfileRoutes extends React.Component<RouteComponentProps<void>, any> {
    render() {
        const match = this.props.match;
        return (
            <Switch>
                <ReloadableRoute path={`${match.url}/details`} render={(props: any) => userProfile(props)} />
                <ReloadableRoute path={`${match.url}/activity`} render={(props: any) => userRecentActivity(props)} />
                <ReloadableRoute path={`${match.url}/apiKeys`} render={(props: any) => userApiKeys(props)} />
                <ReloadableRoute path={`${match.url}/logins`} render={(props: any) => userLogins(props)} />
                <Redirect path={`${match.url}`} exact to={`${match.url}/details`} />
                <RedirectAs404 />
            </Switch>
        );
    }
}

export default UserProfileRoutes;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/users/UserProfileRoutes/UserProfileRoutes.tsx